// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1__d4319db8886f1744ab9c","cls2":"CollapsedActivityPreview-cls2__cb3c6b8a5cb44a9c5635 CollapsedActivityPreview-cls1__d4319db8886f1744ab9c"};